import logo from "../mysql/logo.svg";
import { mysqlConnectionFields, mysqlConnectionString } from "../mysql/shared";
import { rdsIamFields, rdsIamSteps } from "../rdsIam";
import { awsRdsIamAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";

export const awsRdsMysql = defineConnector({
  identifier: "awsRdsMysql",
  name: "AWS RDS MySQL",
  tagLine: "Connect to RDS or Aurora MySQL with IAM",
  logo,
  tags: ["data"],
  protocol: "mysql",
  connectionTest: {
    protocol: "mysql",
    connectionString: (configuration) =>
      mysqlConnectionString(configuration, true),
  },
  defaultUrlPattern: () => "",
  customizeStepHandledInline: true,
  auth: (app) =>
    awsRdsIamAuth({
      roleArn: app.config.roleArn,
      issuer: app.issuer ?? "",
      host: app.config.host,
      port: app.config.port,
      username: app.config.username,
      region: app.config.region,
    }),
  steps: [
    {
      title: "Enter your RDS MySQL connection",
      items: [
        {
          kind: "input",
          label: "Name",
          required: true,
          defaultValue: "AWS RDS MySQL",
          target: { kind: "connectedApp", field: "name" },
        },
        ...mysqlConnectionFields,
        ...rdsIamFields,
        {
          kind: "file",
          label: "CA certificate",
          accept: ".pem,.crt,.cer",
          helperText:
            "Optional PEM CA certificate. RDS IAM connections always use TLS.",
          target: { kind: "configuration", field: "tlsCaCertificate" },
        },
      ],
    },
    ...rdsIamSteps,
  ],
  publicEnvVars: (configuration) => ({
    MYSQL_URL: mysqlConnectionString(configuration, true),
  }),
  usageHint: () => "Use process.env.MYSQL_URL as the MySQL connection string.",
});
